// Deve corresponder exatamente ao nome do role no backend.
export const PLATFORM_ADMIN_ROLE = 'Administrador da Plataforma';
export const AMS_MANAGER_ROLE = 'Gestor AMS';
export const AMS_ATTENDANT_ROLE = 'Atendente AMS';
export const TEAM_TRACKING_MANAGER_ROLE = 'Gestor de Acompanhamento';

export type PlatformRoleName =
  | typeof PLATFORM_ADMIN_ROLE
  | typeof AMS_MANAGER_ROLE
  | typeof AMS_ATTENDANT_ROLE
  | typeof TEAM_TRACKING_MANAGER_ROLE;

export interface PermissionInfo {
  id: number;
  name: string;
  description?: string;
}

export interface RoleInfo {
  id: number;
  name: string;
  description?: string;
  permissions?: PermissionInfo[];
}

export interface UserPlatformProfile {
  id: string;
  name: string;
  email: string;
  avatar?: string;
  roles: RoleInfo[];
}
